import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { studentsReceiptFetch } from '../../../../api-client/api-gqadmin-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const getStudentsReceipts = createAsyncThunk(
    'getStudentsReceipts/Get',
    async (body, { rejectWithValue }) => {
        try {
            const response = await studentsReceiptFetch(body);
            const data = response.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'GET_GQ_ADMIN_STUDENTS_RECEIPTS_FETCH_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

export const getStudentsReceiptsSlice = createSlice({
    name: 'getStudentsReceipts',
    initialState,
    extraReducers: {
        [getStudentsReceipts.pending]: (state) => {
            state.loading = true;
        },
        [getStudentsReceipts.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
        },
        [getStudentsReceipts.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const getStudentsReceiptsSelector = (state) => state.getStudentsReceipts;
export const getStudentsReceiptsReducer = getStudentsReceiptsSlice.reducer;
